import { ListColumn, ListDataColumn } from "../ListColumn";
import { MedicinalProductsListView } from "./MedicinalProductsListView";

export class ROAEntityListView extends MedicinalProductsListView {

        constructor(items: any) {

            const itemFinderArrayColumns=[
                new ListColumn("Num", ListDataColumn.TEXT, "num"),
                new ListColumn("EV Code", ListDataColumn.TEXT, "ev_Code"),
                new ListColumn("Administration Route Name", ListDataColumn.TEXT, "name_Admroute"),
                new ListColumn("Type", ListDataColumn.LOOKUP, "type_Term", "type_Term"),
                new ListColumn("Validated", ListDataColumn.YESNODATETIME, "validated"),
                new ListColumn("Nullified", ListDataColumn.YESNODATETIME, "stamp_nullif"),
                new ListColumn("Deprecated", ListDataColumn.LOOKUP, "deprecated", "yesNo")
            ];

            const itemFinderTreeColumns=[
                new ListColumn("EV Code", ListDataColumn.TEXT, "ev_Code"),
                new ListColumn("Administration Route Name", ListDataColumn.TEXT, "name_Admroute"),
                new ListColumn("Type", ListDataColumn.LOOKUP, "type_Term", "type_Term"),
                new ListColumn("Validated", ListDataColumn.YESNODATETIME, "validated"),
                new ListColumn("Nullified", ListDataColumn.YESNODATETIME, "stamp_nullif"),
                new ListColumn("Deprecated", ListDataColumn.LOOKUP, "deprecated", "yesNo")
            ];

            super(items,itemFinderArrayColumns,itemFinderTreeColumns);


    }

}